import cn from 'classnames'

import { Checkbox } from '@components/Checkbox'
import { CheckboxFieldProps } from './interface'

export function CheckboxField({ label, ...props }: CheckboxFieldProps) {
  return <Checkbox label={label} {...props} />
}
